<template>

    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <Cactivity :navsub="navsub" :options="c_myoption" v-if="isload" :grouplist="grouplist"></Cactivity>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'activities',
        mixins: [mixinmember],
        components: {
            Cactivity: () => import('@/components/Cactivity')
        },
        data() {
            return {
                curnavkv: 22
            };
        },
        computed: {
            c_options: function () {
                let _options = {
                    'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'noteng': 1, 'issch': 0, 'hasgroup': 1, 'showschool': true, 'showgroup': true
                };
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            }
        }
    }
</script>
